import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { Msg } from '../../model/user.model';
import { AccountRequestService } from '../../service/account-request.service';

@Component({
    selector: 'resend-confirmation-code',
    templateUrl: './resend-confirmation-code.component.html',
    styleUrls: ['./resend-confirmation-code.component.scss']
})
export class ResendConfirmationCodeComponent implements OnInit {
    form: UntypedFormGroup;
    isLoading: boolean = false;

    msg: Msg = new Msg();

    constructor(private fb: UntypedFormBuilder, private accountRequestService: AccountRequestService, private router: Router, private store: Store<AppState>) {
        this.form = fb.group({
            email: ['', [Validators.email, Validators.required]],
            captcha: ['', []]
        });
    }

    ngOnInit(): void {}

    submit() {
        this.isLoading = true;
        const val = this.form.value;
        this.accountRequestService
            .resendEmailConfirmationCode(val.email)
            .pipe()
            .subscribe((res) => {
                this.isLoading = false;
                if (res['msg']) {
                    this.msg = res['msg'];
                }
            });
    }
}
